import React from 'react';
import { formatUTCDate } from '../../utils/dateUtils';
import { CheckCircle2, Clock, XCircle } from 'lucide-react';
import { useFollowUpReminders } from '../../hooks/useFollowUpReminders';
import ReactMarkdown from 'react-markdown';

interface FollowUpRemindersProps {
  contactId: string;
}

export default function FollowUpReminders({ contactId }: FollowUpRemindersProps) {
  const { reminders, loading, error, markComplete } = useFollowUpReminders(contactId);

  if (loading) {
    return <div className="text-gray-400">Loading reminders...</div>;
  }

  if (error) {
    return <div className="text-red-500">{error}</div>;
  }

  const pendingReminders = reminders.filter(r => !r.completed);
  
  if (pendingReminders.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold flex items-center gap-2">
        <Clock className="w-5 h-5 text-primary-500" />
        Follow Up Reminders
      </h3>
      
      <div className="space-y-4">
        {pendingReminders.map((reminder) => (
          <div key={reminder.id} className="card p-4 border-l-4 border-l-primary-500">
            <div className="flex justify-between items-start">
              <div className="space-y-2">
                <div className="text-sm text-primary-400">
                  Due {formatUTCDate(reminder.due_date)}
                </div>
                <div className="prose prose-invert max-w-none">
                  <ReactMarkdown>{reminder.description}</ReactMarkdown>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => markComplete(reminder.id)}
                  className="text-gray-400 hover:text-primary-500 p-1"
                  title="Mark as complete"
                >
                  <CheckCircle2 className="w-5 h-5" />
                </button>
                <button
                  onClick={() => markComplete(reminder.id)}
                  className="text-gray-400 hover:text-red-500 p-1"
                  title="Clear reminder"
                >
                  <XCircle className="w-5 h-5" />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}